import { render, staticRenderFns } from "./BasketCollapse.vue?vue&type=template&id=5bba2cc2&scoped=true&"
import script from "./BasketCollapse.vue?vue&type=script&lang=js&"
export * from "./BasketCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BasketCollapse.vue?vue&type=style&index=0&id=5bba2cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba2cc2",
  null
  
)

export default component.exports